<template>
    <v-card variant="outlined" class="hotel-info-relative-positions mb-5">
        <template v-for="(relativePositionGroup, index) in relativePositionGroups">
            <template v-if="relativePositionGroup.relativePositions.length">
                <v-card-title :key="index + '_0'" class="text-h6 font-weight-light">
                    {{ $t(relativePositionGroup.title) }}
                </v-card-title>
                <v-list :key="index + '_1'" density="compact">
                    <template
                        v-for="(relativePosition, relativePositionIndex) in relativePositionGroup.relativePositions"
                        :key="relativePositionIndex"
                    >
                        <v-list-item>
                            <v-list-item-title class="text-capitalize">
                                {{ relativePosition.name }}
                            </v-list-item-title>
                            <template v-if="relativePosition.distance" v-slot:append>
                                {{ relativePosition.distance }}&nbsp;{{ $t('km') }}
                            </template>
                        </v-list-item>
                        <v-divider
                            v-if="relativePositionIndex + 1 < relativePositionGroup.relativePositions.length"
                            :key="relativePositionIndex + '_1'"
                        />
                    </template>
                </v-list>
            </template>
        </template>
    </v-card>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    const transportTypes = ['Airport', 'RailwayStation', 'OutsideCity']

    @Component
    export class HotelInfoRelativePositions extends Vue {
        get relativePositionGroups() {
            const relativePositions = hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo.relativePositions
                ? hotelsRuntimeStore.hotelInfoResponse.hotelDescriptionInfo.relativePositions.relativePosition
                : []
            return [
                {
                    title: 'transport',
                    relativePositions: relativePositions.filter(
                        relativePosition => transportTypes.indexOf(relativePosition.type) !== -1
                    ),
                },
                {
                    title: 'tourist_attractions',
                    relativePositions: relativePositions.filter(
                        relativePosition => transportTypes.indexOf(relativePosition.type) === -1
                    ),
                },
            ]
        }
    }

    export default HotelInfoRelativePositions
</script>
